import { BaseModel } from './base.model';
import { Expose } from 'class-transformer';
import { IPermission, IPermissionConfig } from '../interfaces';

export class Permission extends BaseModel implements IPermission {
  @Expose()
  id!: number;

  @Expose()
  module!: string;

  @Expose()
  feature!: string;

  @Expose()
  scope!: string;

  @Expose()
  slug!: string;

  @Expose()
  description!: string;

  @Expose()
  name?: string;
}

export class PermissionConfig extends BaseModel implements IPermissionConfig {
  @Expose()
  prefix?: string[];

  @Expose()
  redirectCommand?: string[];
}
